<template>
  <div id="push-list" slot="left">
    <Info :info="info"/>
    <TableDef :rows="messages">
      <template slot="slot_head">
        <th :style="{width: '170px'}">推播類型</th>
        <th :style="{textAlign: 'start', width: 'inherit'}">內容</th>
        <th :style="{width: '180px'}">受眾對象/條件</th>
        <th :style="{width: '170px'}">傳送受眾人數</th>
        <th :style="{textAlign: 'start', width: '10em'}">傳送時間</th>
        <th :style="{textAlign: 'end', width: '6em'}">操作人員</th>
        <th :style="{textAlign: 'start', width: '10em', paddingLeft: '2em'}">取消時間</th>
        <th :style="{textAlign: 'end', width: '6em'}">取消人員</th>
      </template>
      <tr slot-scope="{item}" class="record" :style="{minHeight: '100px', borderBottom: '1px solid #B9B9B9'}"
      @click="selected=selected?._id === item._id ? null : item"
      :class="selected?._id === item._id ? 'selected' : ''">
        <td><div class="type" :style="{
          backgroundColor: (item.messageType === 'coupon' || item.messageType === 'couponWithText')
          ? '#FFB55F' :
          toDateTime(item.sendTime) !== toDateTime(item.createTime) ? '#CCA16E'
          : 'var(--color-checked)'
          }">
          {{
          (item.messageType === 'coupon' || item.messageType === 'couponWithText')
          ? '票券發送' :
          (toDateTime(item.sendTime) !== toDateTime(item.createTime) && /coupon/.test(item.messageType)) ? '預約票券' :
          (toDateTime(item.sendTime) !== toDateTime(item.createTime) && !/coupon/.test(item.messageType)) ? '預約活動'
          : '活動公告'}}
        </div></td>
          <td :style="{paddingBlock: '14px', textAlign: 'start'}">
            <div class="message" v-if="item.messageType==='text'||item.messageType==='couponWithText'" :style="{marginBottom: item.messageType==='couponWithText'?'10px':''}">文字訊息: {{item.textContent}}</div>
            <div v-if="item.coupons">
              <CouponBox v-if="item.couponsInfo&&item.couponsInfo[0]&&item.couponsInfo[0].coupon"
              :style="{width: '100%', maxWidth: '650px', boxSizing: 'border-box', borderRadius:'5px'}"
              :image="item.couponsInfo[0].coupon.image||''"
              :couponName="item.couponsInfo[0].coupon.couponName"
              :productName="item.couponsInfo[0].coupon.productName"
              :productID="item.couponsInfo[0].coupon.productID"
              :startTime="item.couponsInfo[0].coupon.startTime"
              :expireTime="item.couponsInfo[0].coupon.expireTime"
              :duration="item.couponsInfo[0].coupon.duration"
              :icon="'none'"
              />
              <CouponBox v-else-if="item.coupons&&item.coupons[0]&&item.coupons[0].coupon"
              :style="{width: '100%', maxWidth: '650px', boxSizing: 'border-box', borderRadius:'5px'}"
              :image="item.coupons[0].coupon.image||''"
              :couponName="item.coupons[0].coupon.couponName"
              :productName="item.coupons[0].coupon.productName"
              :productID="item.coupons[0].coupon.productID"
              :startTime="item.coupons[0].coupon.startTime"
              :expireTime="item.coupons[0].coupon.expireTime"
              :duration="item.coupons[0].coupon.duration"
              :icon="'none'"
              />
              <div class="flexrow">
                優惠券 {{item.coupons.length}}項
                小計 {{reduce(item.coupons.map(e => e.count))}}張
                共計發出 {{item.sended}}張
              </div>
            </div>
            <CouponBox v-if="item.couponInfo"
            :style="{width: '100%', maxWidth: '650px', boxSizing: 'border-box', borderRadius:'5px'}"
            :image="item.couponInfo.image||''"
            :couponName="item.couponInfo.couponName"
            :productName="item.couponInfo.productName"
            :productID="item.couponInfo.productID"
            :startTime="item.couponInfo.startTime"
            :expireTime="item.couponInfo.expireTime"
            :duration="item.couponInfo.duration"
            :icon="'none'"
            />
            <CouponBox v-else-if="item.coupon"
            :style="{width: '100%', maxWidth: '650px', boxSizing: 'border-box', borderRadius:'5px'}"
            :image="item.coupon.image||''"
            :couponName="item.coupon.couponName"
            :productName="item.coupon.productName"
            :productID="item.coupon.productID"
            :startTime="item.coupon.startTime"
            :expireTime="item.coupon.expireTime"
            :duration="item.coupon.duration"
            :icon="'none'"><div class="iconTemplate">樣</div></CouponBox>
            <div class="message" v-if="item.messageType==='image'" :style="{minHeight: '300px'}">
              <img :src="`${VUE_APP_BASE_URL}/message/${item.imageUrl}`" :style="{maxHeight:'272px'}"></div>
            <div class="bubble" v-if="item.messageType==='bubble'">
              <div :style="{maxHeight: '180px'}"><img :src="`${VUE_APP_BASE_URL}/${item.bubbleImage}`" :style="{maxHeight: '180px'}"></div>
              <div>
                <div>{{item.bubbleHeader}}</div>
                <a :href="item.bubbleLink" v-if="item.bubbleLink" :title="item.bubbleLink">{{item.bubbleLink.split('/').slice(0, 4).join('/')}}{{item.bubbleLink.split('/').length>4?'...':''}}</a>
                <div class="bubble-content">{{item.bubbleContent}}</div>
              </div>
            </div>
          </td>
          <td class="poptd" :style="{paddingBlock: '21px'}">
            <div class="ff" v-if="item.targets&&item.targets.length>0" @click="targets=item.targets">
              <span>查看受眾</span>
              <div class="pop1" v-if="item.targets.length>0">
                <div v-for="(us, u) in item.targets" :key="`target-${u}`">
                  <div>{{us.name}} {{us.mobile}}</div>
                  <div>{{us.lineName}}</div>
                </div>
              </div>
            </div>
            <div class="ff" v-else>
              <span>查看受眾</span>
              <div class="pop" :class="getpopava" v-if="getpopava(item.targetFilters)">
              <div v-if="item.targetFilters.role&&item.targetFilters.role.length>0">
                <div>角色</div>
                <div>{{item.targetFilters.role.map(e => roles[e]).join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.gender&&item.targetFilters.gender.length>0">
                <div>性別</div>
                <div>{{item.targetFilters.gender.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.age&&item.targetFilters.age.legnth>0">
                <div>年齡</div>
                <div>{{item.targetFilters.age.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.country&&item.targetFilters.country.length>0">
                <div>地區</div>
                <div>{{item.targetFilters.country.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.consumeNumber">
                <div>條件</div>
                <div></div>
                <div>{{item.targetFilters.consume}} {{item.targetFilters.consumeNumber}} 元</div>
              </div>
            </div>
            </div>
            <div :style="{marginTop: '3px'}">{{item.targetFilters?.consume||'無'}}</div>
          </td>
          <td>{{(item.targets||[]).length}}</td>
          <td :style="{textAlign: 'start'}" v-html="moment(item.sendTime).format('YYYY/MM/DD<br>HH:mm')"></td>
          <td :style="{textAlign: 'end'}">{{item.activeBy?.name||''}}</td>
          <td :style="{textAlign: 'start', paddingLeft: '2em'}" v-html="item.cancelTime ? moment(item.cancelTime).format('YYYY/MM/DD<br>HH:mm') : ''"></td>
          <td :style="{textAlign: 'end'}">{{item.cancelBy?.name||''}}</td>
      </tr>
    </TableDef>
    <infoSliderV2 :show="selected" :icon="'push'" :btnText="'匯出'" :printBtn="true" @printInfo="printInfo"
    @close="selected=null" :label="`${toDateTime(selected?.sendTime)}<br>[${filters}]${messageType}`"
    :style="{zIndex: '999', top: '90px', height: 'calc(100vh - 90px)!important', position: 'absolute'}">
    <div class="tgsbox" v-if="selected">
      <template v-if="selected.couponsInfo&&selected.couponsInfo[0]&&selected.couponsInfo[0].count">
        <CouponBox1 v-for="({coupon, count}, c) in selected.couponsInfo" :key="`select-coupon-${c}`"
        :image="coupon.image||''"
        :couponName="coupon.couponName"
        :productName="coupon.productName"
        :productID="coupon.productID"
        :startTime="coupon.startTime"
        :expireTime="coupon.expireTime"
        :duration="coupon.duration"
        :sendTime="selected.sendTime"
        :icon="'none'"><div class="couponCount" v-if="count" slot="any">{{count}}張</div></CouponBox1>
      </template>
      <CouponBox1 v-if="selected.couponInfo"
      :image="selected.couponInfo.image||''"
      :couponName="selected.couponInfo.couponName"
      :productName="selected.couponInfo.productName"
      :productID="selected.couponInfo.productID"
      :startTime="selected.couponInfo.startTime"
      :expireTime="selected.couponInfo.expireTime"
      :duration="selected.couponInfo.duration"
      :sendTime="selected.sendTime"
      :icon="'none'"/>
      <CouponBox1 v-else-if="selected.coupon"
      :image="selected.coupon.image||''"
      :couponName="selected.coupon.couponName"
      :productName="selected.coupon.productName"
      :productID="selected.coupon.productID"
      :startTime="selected.coupon.startTime"
      :expireTime="selected.coupon.expireTime"
      :duration="selected.coupon.duration"
      :sendTime="selected.sendTime"
      :icon="'coupon'"><div class="iconTemplate">樣</div></CouponBox1>
      <h1>發送條件</h1>
      <div class="targetFilters" v-if="selected.targetFilters.consume !== '指定'">
        <div v-if="selected.targetFilters.role"><div>會員類別:</div> <div><span v-for="r in selected.targetFilters.role.map(r => roles[r])" :key="r">{{r}}</span></div></div>
        <div v-else><div>會員類別:</div> <div>不限</div></div>
        <div v-if="selected.targetFilters.country"><div>縣市:</div> <div :style="{display: 'flex', flexWrap: 'wrap', gap: '10px'}"><span v-for="r in selected.targetFilters.country" :key="`country-${r}`">{{r}}</span></div></div>
        <div v-else><div>縣市:</div> <div>不限</div></div>
        <div v-if="selected.targetFilters.gender"><div>性別:</div> <div>{{selected.targetFilters.gender.join(' / ')}}</div></div>
        <div v-else><div>性別:</div> <div>不限</div></div>
        <div v-if="selected.targetFilters.age"><div>年齡:</div> <div :style="{display: 'flex', flexWrap: 'wrap', gap: '10px'}"><span v-for="(a, g) in JSON.parse(selected.targetFilters.age)" :key="`ag-${g}`"><span v-if="a.$gte">{{a.$gte}}歲以上</span><span v-if="a.$lte">{{a.$lte}}歲以下</span></span></div></div>
        <div v-else><div>年齡:</div> <div>不限</div></div>
        <div v-if="selected.targetFilters.consume"><div>消費:</div><div>{{selected.targetFilters.consume}} {{selected.targetFilters.consumeNumber}}</div></div>
        <div v-else><div>消費:</div> <div>不限</div></div>
      </div>
      <div class="targetFilters" v-else>指定對象發送 </div>
      <h1 :style="{display: 'flex', alignItems:'center', justifyContent: 'space-between'}" >發送對象({{selected.targets.length}}人) <numInput :defaultValue="userpage" @input="userpage=$event"/></h1>
      <div v-for="(tg, t) in selected.targets.slice((userpage-1)*18, userpage*18)" :key="`tg-${t}`" class="tgs">
        <div>{{(userpage-1)*18 + 1 + t}}. </div>
        <div>{{tg.name}}</div>
        <div>{{tg.lineName}}</div>
      </div>
      <div :style="{marginTop: 'auto'}" v-if="selected.sended">
        <button class="fillwidthBtn" @click="cancelId=selected._id">刪除已發送優惠券</button>
      </div>
    </div>
    </infoSliderV2>
    <DialogDef2 :show="cancelId" :label="'刪除已發送優惠券'">
      <div class="warning">
        <div>確定要刪除已發送優惠券</div>
        <BtnsS @cancel="cancelId=null" :save="'確定刪除'" @save="cancel"/>
      </div>
    </DialogDef2>
  </div>
</template>

<script>
import CouponBox from '../../components/couponBox.vue'
import numInput from '../../components/input/page.vue'
import XLSX from 'xlsx'
import infoSliderV2 from '../../components/infoSlider_v2.vue'
import CouponBox1 from '../../components/couponBox1.vue'
import Info from './message/lineinfobox.vue'
import { getapi, postapi } from '../../store/fetch'
import TableDef from '../../components/tables/t2.vue'
const { VUE_APP_BASE_URL } = process.env
export default {
  props: ['info', 'page'],
  components: {
    Info,
    CouponBox,
    TableDef,
    infoSliderV2,
    CouponBox1,
    numInput
  },
  data () {
    return {
      VUE_APP_BASE_URL,
      messages: [],
      count: 0,
      cancelId: null,
      types: {
        couponWithText: ''
      },
      selected: null,
      userpage: 1,
      roles: {
        agency: '代理商窗口',
        leader: '領隊導遊',
        user: '會員'
      }
    }
  },
  watch: {
    async page () { await this.getmessage() }
  },
  async mounted () {
    await this.getmessage()
  },
  computed: {
    filters () {
      if (this.selected && this.selected.targetFilters?.consume === '指定') {
        return '指定'
      } else {
        return '條件'
      }
    },
    messageType () {
      switch (this.selected?.messageType) {
        case 'couponWithText':
          return '文字訊息與票券'
        case 'coupon':
          return '票券'
        case 'text':
          return '文字訊息'
        case 'image':
          return '圖片訊息'
        case 'bubble':
          return '圖文訊息'
        default:
          return ''
      }
    }
  },
  methods: {
    async cancel () {
      const r = await postapi(`message/cancel/${this.cancelId}`)
      if (r) {
        this.selected = r
        this.cancelId = null
        await this.getmessage()
      }
    },
    getExData (e) {
      return {
        發送對象: e.name,
        發送對象LINE: e.lineName,
        發送對象電話: e.mobile
      }
    },
    getExData2 () {
      return [
        { 欄位名稱: '訊息類別', 欄位內容: this.messageType },
        { 欄位名稱: '發送時間', 欄位內容: this.toDateTime(this.selected.sendTime) },
        { 欄位名稱: '受眾人數', 欄位內容: this.selected.targets.length },
        { 欄位名稱: '發送人員', 欄位內容: this.selected.activeBy?.name },
        ...(this.selected.coupon ? [
          { 欄位名稱: '票券名稱', 欄位內容: this.selected.coupon.couponName },
          { 欄位名稱: '贈品名稱', 欄位內容: this.selected.coupon.productName },
          { 欄位名稱: '可用地點', 欄位內容: this.selected.coupon.store.join(' | ') },
          { 欄位名稱: '開始時間', 欄位內容: this.toDateTime(this.selected.coupon.startTime) },
          { 欄位名稱: '有效期限', 欄位內容: this.toDateTime(this.selected.coupon.expireTime) }
        ] : []),
        ...(this.selected.textContent ? [
          { 欄位名稱: '文字訊息', 欄位內容: this.selected.textContent }
        ] : []),
        ...(this.selected.imageUrl ? [
          { 欄位名稱: '圖片訊息', 欄位內容: /https/.test(this.selected.imageUrl) ? this.selected.imageUrl : window.location.origin + VUE_APP_BASE_URL + this.selected.imageUrl }
        ] : []),
        ...(this.selected.bubbleImage ? [
          { 欄位名稱: '圖文訊息_圖片', 欄位內容: /https/.test(this.selected.bubbleImage) ? this.selected.bubbleImage : window.location.origin + VUE_APP_BASE_URL + this.selected.bubbleImage },
          { 欄位名稱: '圖文訊息_標題', 欄位內容: this.selected.bubbleHeader },
          { 欄位名稱: '圖文訊息_內容', 欄位內容: this.selected.bubbleContent },
          { 欄位名稱: '圖文訊息_連結', 欄位內容: this.selected.bubbleLink }
        ] : [])
      ]
    },
    printInfo () {
      const workbook = XLSX.utils.book_new()
      const data = JSON.parse(JSON.stringify(this.selected.targets))
      const json = data.map(e => this.getExData(e))
      const worksheet = XLSX.utils.json_to_sheet(json)
      XLSX.utils.book_append_sheet(workbook, worksheet, '對象')
      const worksheet1 = XLSX.utils.json_to_sheet(this.getExData2())
      XLSX.utils.book_append_sheet(workbook, worksheet1, '訊息')
      const name = `${this.toDateTime(this.selected.createTime)}_${this.messageType}_訊息發送對象`
      XLSX.writeFile(workbook, `${name}.xlsx`)
    },
    getpopava (ev) {
      if (!ev) {
        return false
      }
      if (Object.keys(ev).length === 1 && Object.keys(ev)[0] === 'consume') {
        return false
      }
      if ((ev.role || []).length === 0 && (ev.age || []).length === 0 && (ev.country || []).length === 0 && (ev.gender || []).length === 0 && !ev.consumeNumber) {
        return false
      }
      console.log('ev', Object.keys(ev), Object.keys(ev).length, ev[Object.keys(ev)[0]])
      return true
    },
    async getmessage () {
      const params = {
        page: this.page
      }
      const messages = await getapi('message?' + new URLSearchParams(params))
      this.messages = messages.data
      this.count = messages.count
      this.$emit('count', this.count)
    }
  }

}
</script>

<style lang="scss">
#push-list {
  thead>tr {
    background-color: #E8E8E8;
    th {
      color: #787878;
      &:last-child {
        padding-right: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.warning {
  height: 230px;
  font-size: 24px;
  gap: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  letter-spacing: .1em;
}
.fillwidthBtn {
  width: 100%;
  background-color: var(--color-pri);
  color: #FFFFFF;
  height: 45px;
  border-radius: 3px;
  letter-spacing: .1em;
}
.couponCount {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: var(--color-pri);
  font-weight: 700;
  letter-spacing: .1em;
}
.iconTemplate {
  width: 30px;
  height: 30px;
  font-size: 16px;
  color: #787878;
  border-radius: 50%;
  border: 1px solid #787878;
  display: flex;
  align-items: center;
  justify-content: center;
}
.targetFilters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 20px;
  letter-spacing: .1em;
  padding-block: 10px 20px;
  max-width: 480px;
  gap: 10px;
  &>div{
    display: flex;
    gap: 20px;

    &>div:nth-child(1) {
      min-width: 5em;
      text-align: end;
    }
    &>div:nth-child(2) {
      white-space: pre-wrap;
    }
  }
}
.tgsbox {
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: calc(100vh - 187px);
  h1 {
    font-size: 24px;
    color: var(--color-pri);
    font-weight: 700;
    text-align: start;
  }
}
.tgs {
  padding-inline: 20px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.message {
  min-width: 650px;
  padding: 10px;
  border: 1px solid #B9B9B9;
  width: fit-content;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
  box-sizing: border-box;
  img {
    box-sizing: border-box;
  }
}
.bubble {
  display: flex;
  gap: 23px;
  padding: 10px;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  max-height: 200px;
  font-size: 18px;
  &>div:nth-child(2) {
    overflow-y: auto;
    &>div:nth-child(1) {
      font-weight: bold;
    }
  }
}
.ff {
    margin: auto;
    width: 130px;
    height: 40px;
    background: #B9B9B9;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    display: flex;align-items: center;justify-content: center;
  }
.type {
    margin: auto;
    width: 100px;
    height: 40px;
    background: #B9B9B9;
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    display: flex;align-items: center;justify-content: center;
}
.pop {
  display: none;
  position: absolute;
  width: 385px;
  height: fit-content;
  flex-direction: column;
  background: #ECF3FF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  padding: 25px 28px;
  z-index: 10;
  gap: 15px;
  top: 49px;
  left: 0;
  &>div{
    display: flex;
    gap: 27px;
    align-items: flex-start;
    &>div:nth-child(1) {
      width: 40px;
      flex-wrap: nowrap;
      white-space: nowrap;
    }
    &>div:nth-child(2) {
      text-align: start;
    }
  }
}
.pop1 {
  display: none;
  position: absolute;
  min-width: 285px;
  width: fit-content;
  height: fit-content;
  max-height: 700px;
  overflow-y: auto;
  flex-direction: column;
  background: #ECF3FF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: right;
  letter-spacing: 0.1em;
  color: #517FA4;
  padding: 25px 28px;
  z-index: 10;
  gap: 15px;
  top: 49px;
  left: 0;
  gap: 20px;
  &>div{
    display: flex;
    gap: 27px;
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
    &>div:nth-child(1) {
      flex-wrap: nowrap;
      white-space: nowrap;
    }
    &>div:nth-child(2) {
      text-align: start;
    }
  }
}
.ff {
  position: relative;
}
.ff:hover{
  .pop {
    display: flex;
  }
  .pop1 {
    display: flex;
  }
}
.record {
  border-bottom: 1px solid #B9B9B9;
  td {
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.1em;
    color: #787878;
    &:last-child {
      padding-right: 32px;
      }
  }
  &.selected {
    background-color: var(--color-infobox);
  }
}
#push-list {
  // padding: 18px 32px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 90px);
}
</style>
